<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>📅 Crear nuevo evento</span>
  <button mat-icon-button (click)="close()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form (ngSubmit)="save()" #form="ngForm" class="event-form" novalidate>
    <mat-dialog-content>

        <app-input inputType="text" placeholder="Título" name="title" class="full-width" [isRequired]="true"
            [(ngModel)]="newEvent.title"></app-input>

        <div class="row">
            <!-- Contacto -->
            <div class="col-md-6">
                <app-autocomplete-select [items]="contacts" [(selectedItemId)]="newEvent.contactUid" [idField]="'uid'"
                    [displayField]="'companyName'" placeholder="Contactos">
                </app-autocomplete-select>
            </div>
            <div class="col-md-6">
                <app-autocomplete-select [items]="concepts" [(selectedItemId)]="newEvent.conceptUid" [idField]="'uid'"
                    [displayField]="'name'" placeholder="Conceptos">
                </app-autocomplete-select>
            </div>

            <!-- <mat-form-field appearance="outline" class="half-width">
                <mat-label>Contacto</mat-label>
                <input type="text" [(ngModel)]="newEvent.contactUid" matInput placeholder="Buscar contacto"
                    [formControl]="contactControl" [matAutocomplete]="autoContact" />
                <mat-autocomplete #autoContact="matAutocomplete" (optionSelected)="selectContact($event.option.value)">
                    <mat-option *ngFor="let contact of filteredContacts | async; trackBy: trackByIndex" [value]="contact.companyName">
                        {{ contact.companyName }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field> -->

            <!-- Concepto -->
            <!-- <mat-form-field appearance="outline" class="half-width">
                <mat-label>Conceptos</mat-label>
                <input type="text" [(ngModel)]="newEvent.conceptUid" matInput placeholder="Buscar concepto"
                    [formControl]="conceptControl" [matAutocomplete]="autoConcept" />
                <mat-autocomplete #autoConcept="matAutocomplete" (optionSelected)="selectConcept($event.option.value)">
                    <mat-option *ngFor="let concept of filteredConcepts | async; trackBy: trackByIndex" [value]="concept.name">
                        {{ concept.name }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field> -->
        </div>


        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Descripción</mat-label>
            <textarea matInput [(ngModel)]="newEvent.description" name="description"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Observaciones</mat-label>
            <textarea matInput [(ngModel)]="newEvent.observations" name="observations"></textarea>
        </mat-form-field>

        <div class="date-row">
            <app-input inputType="datetime-local" placeholder="Fecha inicio" name="startDate" class="half-width" [isRequired]="true"
                [(ngModel)]="newEvent.startDate"></app-input>

            <app-input inputType="datetime-local" placeholder="Fecha fin" name="endDate" class="half-width" [isRequired]="true"
                [(ngModel)]="newEvent.endDate"></app-input>
        </div>

        <mat-checkbox [(ngModel)]="newEvent.isAllDay" name="isAllDay">
            Evento de todo el día
        </mat-checkbox>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">Guardar</button>
        <button mat-button type="button" (click)="close()">Cancelar</button>
    </mat-dialog-actions>
</form>